'use strict';

(function ($, window, undefined) {
  window.DK.GiftListSelector = GiftListSelector;
  $.fn.giftList = function (options) {
    function addItemsToList(currentTarget, list, giftListSelector) {
      let items = window.DK.giftListItems.map(function (input, i) {
        return giftListSelector.createListItem(list.id, input.skuId, input.price, input.quantity);
      });
      giftListSelector.addItemsToList(list.id, items).done(function (data) {
        displayGiftListFeedback(data, $(currentTarget), list);
        document.dispatchEvent(new CustomEvent('add-items-to-gift-list-event'));
      });
    }
    function displayGiftListFeedback(data, $elm, giftList) {
      if (data.failure || !data.itemAdded) {
        return;
      }
      bootstrap.Modal.getInstance($('.modal.show')[0]).hide();
      displayToast(giftList);
    }
    function displayToast(giftList) {
      const header = `Item Added to ${giftList.type}`;
      const body = `<a href="/gift-list/details?registryId=${giftList.id}">Go to your ${giftList.name}
			${giftList.type.toLocaleLowerCase()}</a>`;
      $.toast({
        type: 'success',
        title: header,
        content: body,
        delay: 5000
      });
    }

    /**
     * Attaches the new gift list button event handlers to the modal
     * after the modal is displayed.
     * @param event 'shown.bs.modal' Bootstrap modal event
     */
    function onNewListModalShown(event) {
      let relatedTarget = $(event.relatedTarget);
      let data = eval(relatedTarget.data('gl'));
      window.DK.giftListItems = data;
    }
    return this.each(function (index, element) {
      let giftListSelector = new GiftListSelector(element);

      // Attaches the 'click' event handler to each gift list in
      // the dropdown menu to allow adding an item to that gift list.
      giftListSelector.giftLists.forEach(function (list) {
        $(list.element).off('click').on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          addItemsToList(e.currentTarget, list, giftListSelector);
        });
      });

      // Set up event handlers for the 'Create new wish list/gift
      // registry' buttons inside of the modal. This loads the forms
      // inside of the existing modal rather than loading a new page.
      //$(giftListSelector.createNewButton).on('click', onCreateNewListClick);
      $('#gift-list-modal').on('shown.bs.modal', onNewListModalShown);
      this.giftListSelector = giftListSelector;
      $.data(this, 'giftListSelector', giftListSelector);
      return this;
    });
  };
  function GiftListSelector(elem) {
    this.elem = elem;
    this.$elem = $(elem);
    this.createNewButton = elem.querySelector('.create-new > a');
    this.giftLists = Array.from(elem.querySelectorAll('.giftlist-add-item')).map(function (el) {
      return {
        id: el.id,
        element: el,
        name: el.querySelector('.gift-list-name').textContent,
        type: el.querySelector('.list-title').textContent
      };
    });
  }
  GiftListSelector.prototype.createListItem = function (listId, skuId, price, quantity) {
    if (!listId) {
      throw new Error('listId is required');
    }
    if (!skuId) {
      throw new Error('Invalid sku id');
    }
    if (!price) {
      throw new Error('Price is required');
    }
    let list = this.findListById(listId);
    if (!list) {
      throw new Error(`Unable to find a list with id: ${listId}`);
    }
    return {
      giftListId: list.id,
      giftListName: list.name,
      skuId: skuId,
      addedPrice: price,
      requestQty: quantity || 1
    };
  };
  GiftListSelector.prototype.addItemsToList = function (listId, itemsToAdd) {
    let spinner = new Spinner(),
      $content = this.$elem.find('.modal-content');
    return $.ajax({
      type: 'POST',
      url: '/gift-list/add-item',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(itemsToAdd),
      dataType: 'json',
      beforeSend: function () {
        DK.displayBlocker($content);
        spinner.spin($content.get()[0]);
      },
      complete: function () {
        DK.hideBlocker($content);
        spinner.stop();
      }
    });
  };
  GiftListSelector.prototype.findListById = function (listId) {
    let lists = this.giftLists.filter(function (e) {
      return e.id === listId;
    });
    if (!lists) {
      return;
    }
    return lists[0];
  };
})(window.jQuery, window);
$(function () {
  $('#gift-list-modal').giftList();
});

//Reset gift list modal when it's closed
//only add listener if modal exists.

if ($('#gift-list-modal').length) {
  /* Because this is written badly, we were using the same selector to do
  two different things and when we combined the script caused both to run. This
  adds a differentiator to determine whether to add and item to move one*/
  // $(this).giftList();
  let toMove = $('.js-move-sku-id').length;
  if (toMove) {
    $('#gift-list-modal').addClass('gift-list-modal--move');
  }
}

/* This was in the old gift-lists.js and we combined them into
 ** one file to avoid the ridiculous confusion that came along with that.
 ** These are written terribly, i am sorry to whoever has to look at them
 ** until they are rewritten */
var DK = DK || {};
DK.GiftLists = {
  // Initialize the giftlist page handlers
  init: function () {
    // Click Event to get the sku-id from the _gift-list-item.vm
    $('.js-move-sku-id').on('click', function (e) {
      e.preventDefault();
      DK.GiftLists.getSkuIdToMove($(this));
    });
    $('.gift-list-modal--move [data-giftlist-id]').on('click', function (e) {
      e.preventDefault();
      DK.GiftLists.moveItemToDifferentGiftListOrRegistry($(this));
    });
  },
  getSkuIdToMove: function ($elm) {
    $('.add-to-giftlist a').data('sku-id', $elm.data('gl-sku-id'));
  },
  moveItemToDifferentGiftListOrRegistry: function ($elm) {
    const wlIdFrom = $elm.data('giftlist-id'); //Id of the wish list the item is being moved from
    const wlIdTo = $elm.data('gl-id'); //Id of the wish list the item is being moved to
    const skuId = $elm.data('sku-id');
    const giftListName = $elm.find('span.gift-list-name').text();
    const giftListType = $elm.find('span.list-title').text();
    let spinner = new Spinner();
    $.ajax({
      type: 'POST',
      async: true,
      url: '/gift-list/move-item',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        giftListIdTo: wlIdTo,
        giftListIdFrom: wlIdFrom,
        skuId: skuId
      }),
      beforeSend: function () {
        DK.displayBlocker('#registry-form');
        spinner.spin($elm.get()[0]);
      },
      dataType: 'json',
      context: this
    }).always(function (data) {
      $(`li[data-sku-id='${skuId}'], .cart-sfl__item`).hide();
      bootstrap.Modal.getInstance($('#gift-list-modal')[0]).hide();
      displayToast(wlIdTo, giftListName, giftListType);
      if (data.isEmpty) {
        $('#registry-form').replaceWith(data.emptyHtml);
      }
      DK.hideBlocker('#registry-form');
      spinner.stop();
    }).fail(function (xhr, textStatus, errorThrown) {
      if (window.console) {
        console.log('Error: ' + errorThrown + '\n' + 'Status: ' + textStatus);
        DK.hideBlocker('#registry-form');
        spinner.stop();
      }
      DK.hideBlocker('#registry-form');
      spinner.stop();
    });
  }
};
function displayToast(giftListId, giftListName, giftListType) {
  const header = `Item moved to ${giftListType}`;
  const body = `<a href="/gift-list/details?registryId=${giftListId}">
	Go to your ${giftListName} ${giftListType.toLocaleLowerCase()}</a>`;
  $.toast({
    type: 'success',
    title: header,
    content: body,
    delay: 5000
  });
}
$(function () {
  // Adds item to cart via ajax
  $('a[data-add-cart]').on('click', function (e) {
    e.preventDefault();
    const $elm = $(this);
    const itemPlace = $elm.attr('data-add-cart');
    const skuId = $elm.attr('data-sku-id');
    const registryId = $elm.attr('data-registry-id');
    const itemQuantity = $('#' + itemPlace).val();
    let spinner = new Spinner();
    $.ajax({
      data: {
        skuId: skuId,
        registryId: registryId,
        quantity: itemQuantity
      },
      url: $elm.attr('href'),
      method: 'POST',
      beforeSend: function () {
        DK.displayBlocker('#registry-form');
        spinner.spin($('#registry-form').get()[0]);
      },
      complete: function () {
        DK.hideBlocker('#registry-form');
        spinner.stop();
      },
      success: function (jsonData) {
        let skuIds = jsonData.itemsAddedToCart.map(item => item.skuId);
        let rideId = $("input[name='rideId']").val();
        DK.AddToCart.updateCartStatus(jsonData.cartModalHTML, jsonData.cartItemsCount, jsonData.cartHTML);
        DK.AddToCart.sendListrakTracking(jsonData.listrakCart.items);
        DK.AddToCart.sendGoogleAnalyticsTracking(skuIds, rideId);
        DK.AddToCart.sendGTMTrigger(jsonData.itemsAddedToCart);
      }
    });
  });

  // Initialize the add to cart javascript on each form
  document.querySelectorAll('form[id^=add-to-cart-form]').forEach(form => DK.AddToCart.init(`#${form.id}`));

  /**
   * Handle the email functionality. A modal dialog containing the form
   * is displayed to the user and any failed form validation should
   * remain in the modal. The modal is hidden upon successful form
   * submission and a message will be displayed to the user.
   */
  $(document).off('submit', '#registry-email-to-friend-modal form');
  $(document).on('submit', '#registry-email-to-friend-modal form', function (e) {
    e.preventDefault();
    let spinner = new Spinner();
    $.ajax({
      url: $(this).attr('action'),
      data: $(this).serialize(),
      type: $(this).attr('method'),
      beforeSend: function () {
        DK.displayBlocker('#registry-email-to-friend-modal');
        spinner.spin($('#registry-email-to-friend-modal').get()[0]);
      },
      complete: function () {
        DK.hideBlocker('#registry-email-to-friend-modal');
        spinner.stop();
      }
    }).done(function (data, textStatus, jqXHR) {
      let $html = $(data);
      let $modal = $('#registry-email-to-friend-modal');
      // Use the returned element id to determine if the form
      // submission passed or failed validation
      if ($html[0].id === 'success-message') {
        bootstrap.Modal.getInstance($modal[0]).hide();
        let $messageDiv = $('#registry-messages'),
          messageContent = $(data).html();
        $messageDiv.find('.alert').html(messageContent);
        $messageDiv.show();
      } else {
        let modalContent = $(data)[0];
        $modal.find('.modal-body-content').html(modalContent);
        bootstrap.Modal.getInstance($modal[0]).handleUpdate();
      }
    });
  });

  /**
   * Handle the 'edit details' modal submission.
   */
  $(document).off('submit', 'form#edit-details');
  $(document).on('submit', 'form#edit-details', function (e) {
    e.preventDefault();
    let spinner = new Spinner();
    $.ajax({
      url: this.action,
      data: $(this).serialize(),
      method: this.method,
      beforeSend: function () {
        $('#edit-details-messages').hide();
        DK.displayBlocker('#edit-details');
        spinner.spin($('#edit-details').get()[0]);
      },
      complete: function () {
        DK.hideBlocker('form.content');
        spinner.stop();
      }
    }).done(function (data, textStatus, jqXHR) {
      if (jqXHR.status === 202) {
        // Successful form submission returns a HTTP 202 Accepted
        // status code
        bootstrap.Modal.getInstance($('#gift-list-create')[0]).hide();
        window.location.reload(true);
      } else {
        let modalContent = $(data)[0];
        $('#giftListContent').html(modalContent);
      }
      $('<div class="alert-box success">Wish List has been successfully saved</div>').insertBefore('#edit-details');
    }).fail(function (jqXHR, textStatus, errorThrown) {
      $('#edit-details-messages .alert-box').text('An error occurred. Please try again.');
      $('#edit-details-messages').show();
    });
  });
  let currentPos;
});
$(function () {
  DK.GiftLists.init();

  //Reset gift list modal when it's closed
  //only add listener if modal exists.
  if ($('#gift-list-create').length) {
    $('#gift-list-create')[0].addEventListener('shown.bs.modal', function (e) {
      /* The related target needs the giftList item object attached to it,
       ** This should be separate attributes. Needs to be addressed when this is
       ** rewritten. */
      if (window.DK.giftListItems && window.DK.giftListItems.length > 0) {
        let data = window.DK.giftListItems[0];
        let dataSet = `[{skuId: '${data.skuId}', price: '${data.price}', quantity: '${data.quantity}'}]`;
        $('.gl__form__cta--back').attr('data-gl', dataSet);
      }
    });
  }
});